<template>
	<section id="auth">
		<div class="auth-container">
			<div class="auth-left">
				<router-link :to="{ name: 'home' }" class="lineup-home">
					<img class="logo-lineup" src="../../assets/logos/mate/lineup-pink-bg.svg" alt="LineUp Tickets">
				</router-link>
			</div>
			<div class="auth-right">
				<img src="../../assets/ticketin/Defecto.svg" alt="Ticketin" class="ticketin">
				<div class="auth-right-container">
					<transition name="fade" mode="out-in">
						<register-form v-if="$route.name === 'register'"></register-form>
						<login-form v-if="$route.name === 'login'" @success="loginSuccess" @forgotPassword="$router.push({ name: 'forgot-password-request' })"></login-form>
						<verify-email-form v-if="$route.name === 'verify-email'"></verify-email-form>
						<forgot-password-request-form v-if="$route.name === 'forgot-password-request'" @backToLogin="$router.push({ name: 'login' })"></forgot-password-request-form>
						<forgot-password-form v-if="$route.name === 'forgot-password'"></forgot-password-form>
					</transition>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import RegisterForm from '../../components/RegisterForm.vue'
	import LoginForm from '../../components/LoginForm.vue'
	import VerifyEmailForm from '../../components/VerifyEmailForm.vue'
	import ForgotPasswordRequestForm from '../../components/ForgotPasswordRequestForm.vue'
	import ForgotPasswordForm from '../../components/ForgotPasswordForm.vue'

	import { createNamespacedHelpers } from "vuex";
	const { mapState, mapActions } = createNamespacedHelpers('AuthModule');

	export default {
		components: {
			RegisterForm,
			LoginForm,
			VerifyEmailForm,
			ForgotPasswordRequestForm,
			ForgotPasswordForm
		},
		computed: {
			...mapState({
				callbackAction: state => state.authModal.callbackAction
			})
		},
		mounted(){
			this.hideAuthModal(false);
		},
		methods: {
			...mapActions(['hideAuthModal']),
			callback() {
				this.$store.dispatch(
					this.callbackAction.name,
					this.callbackAction.payload
				);
			},
			loginSuccess() {
				this.callback();
				this.hideAuthModal(true);
			}
		}
	}
</script>

<style lang="scss" scoped>
	#auth{
		position: relative;
		height: 100vh;
		width: 100vw;
		overflow: hidden;
		@include flex(column, center, center);

		.auth-container{
			width: 100%;
			height: 100vh;
			@include flex(row, space-between, center);

			.auth-left{
				position: relative;
				// background: url('https://images.unsplash.com/photo-1658231118307-a2b33617d92b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80');
				// background: url('https://images.unsplash.com/photo-1662318616540-46f046dba067?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2071&q=80');
				// background: url('https://images.unsplash.com/photo-1616352847624-70c3cc59f188?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80');
				// background-size: cover;
				// background-position: center;
				// background-repeat: no-repeat;
				width: calc(100% - 690px);
				height: 100%;

				&::after{
					content: 'Be There.';
					height: 99%;
					width: 99%;
					position: absolute;
					top: 0;
					left: 0;
					text-align: center;
					font-family: var(--font-sora);
					color: var(--color-white);
					font-weight: var(--fw-700);
					font-size: 115px;
					line-height: 1em;
					@include flex(row, center, center);
					z-index: 2;
				}

				&::before{
					content: 'Be There.';
					height: 99%;
					width: 100%;
					position: absolute;
					top: 0;
					left: 0;
					text-align: center;
					font-family: var(--font-sora);
					color: var(--color-primary);
					font-weight: var(--fw-700);
					font-size: 115px;
					line-height: 1em;
					@include flex(row, center, center);
					// background-color: rgba(0, 0, 0, 0.3);
					z-index: 1;

				}

				#myVideo{
					position: relative;
					right: 0;
					bottom: 0;
					min-width: 100%;
					min-height: 100%;
					z-index: 0;
				}

				.lineup-home{
					position: absolute;
					top: 40px;
					left: 0px;
					padding: 30px;
					@include flex(row, flex-start, center);
					text-decoration: none;
					background-color: var(--color-primary);
					z-index: 99;
					@include transition(all .2s);
					cursor: pointer;


					.logo-lineup{
						height: 52px;
						width: auto;
					}

					&:hover{
						opacity: .9;
					}
				}
			}

			.auth-right{
				width: 610px;
				height: calc(100% - 80px);
				@include flex(column, center, center);
				margin: 0px 40px;
				background-color: var(--color-white);
				border-radius: 22px;
				position: relative;

				.auth-right-container{
					width: 100%;
					max-width: 480px;
					padding: 24px;
					@include flex(column, center, flex-start);
				}

				.ticketin{
					position: absolute;
					width: 280px;
					height: auto;
					left: -250px;
					bottom: 10px;
				}
			}
		}
	}

	@media screen and (max-width: 1760px){
		#auth{
			.auth-container{
				.auth-right{
					.ticketin{
						width: 230px;
						left: -210px;
					}
				}
			}
		}
	}

	@media screen and (max-width: 1496px){
		#auth{
			.auth-container{
				.auth-left{
					&::before, &::after{
						font-size: 90px;
					}
				}
			}
		}
	}

	@media screen and (max-width: 1196px){
		#auth{
			.auth-container{
				.auth-left{
					&::before, &::after{
						font-size: 50px;
					}
				}
			}

			.auth-right{
				.ticketin{
					display: none;
				}
			}
		}
	}

	@media screen and (max-width: 968px){
		#auth{
			.auth-container{
				.auth-right{
					width: 100%;
					border-radius: 0px;
					height: 100%;
					margin: 0;
				}

				.auth-left{
					display: none;

					&::before, &::after{
						content: none;
					}
				}
			}
		}
	}

	@media screen and (max-height: 748px){
		#auth{
			.auth-container{
				.auth-right{
					@include flex(column, flex-start, center);
					overflow-y: scroll;

					.ticketin{
						display: none;
					}
				}
			}
		}
	}
</style>